var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Trash = function Trash(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 390 445' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'g',
        { fill: 'currentColor' },
        React.createElement('path', { d: 'M181 184h28v193h-28zM124 184h28v193h-28zM238 184h29v193h-29z' }),
        React.createElement('path', { d: 'M267 65V9H124v56H9v29h29v343h314V94h29V65H267zM152 36h86v30h-86V36zm172 373H67V94h257v315z' })
      )
    )
  );
};
/*eslint-enable */

export default Trash;
//# sourceMappingURL=Trash.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Trash.js